import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-left":"25px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  width: "85",
  style: {"vertical-align":"top"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  width: "300",
  style: {"padding":"0px 20px","background":"#f7f7f7"}
}
const _hoisted_6 = {
  class: "fs16 fw600 mt0 mb5 text-left",
  style: {"color":"#333"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "rad6 centered",
  style: {"background":"#2c96ff","border":"0","width":"160px","height":"30px","padding":"0 17px 0 0"}
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"100%","width":"160px","color":"#fff"} }, [
    /*#__PURE__*/_createElementVNode("strong", { style: {"line-height":"30px","font-size":"12px"} }, "プロフィールを確認")
  ])
], -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { style: {} }, "この日程調整では、以下より担当者をお選びいただけます。", -1)
const _hoisted_10 = { width: "400" }
const _hoisted_11 = {
  width: "85",
  style: {"vertical-align":"top"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  width: "300",
  style: {"padding":"0px 20px","background":"#f7f7f7"}
}
const _hoisted_14 = {
  class: "fw600 fs16 mb5 mt0 text-left",
  style: {"color":"#333"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "rad6 centered noborder",
  style: {"background":"#2c96ff","width":"160px","height":"30px","padding":"0 17px 0 0"}
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"100%","width":"160px","color":"#fff","text-decoration":"none"} }, [
    /*#__PURE__*/_createElementVNode("strong", {
      class: "fs12",
      style: {"line-height":"30px"}
    }, "プロフィールを確認")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.rcm.astag && _ctx.rcm.astag.mag_type == `display_and_selectable` && _ctx.Util.isPresent(_ctx.rcm.astag.meeting_attendees_groups))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.rcm.astag.meeting_attendees_groups.length == 1 || _ctx.isFix)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, "今回は、「" + _toDisplayString(_ctx.rcm.astag.meeting_attendees_groups[0].team_name) + "」が担当いたします。", 1),
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_3, [
                    (
                                _ctx.rcm.astag.meeting_attendees_groups[0].profile_image_urls &&
                                _ctx.rcm.astag.meeting_attendees_groups[0].profile_image_urls[0]
                            )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          "data-imagetype": "External",
                          src: _ctx.rcm.astag.meeting_attendees_groups[0].profile_image_urls[0],
                          width: "80",
                          height: "80",
                          style: {"border-radius":"50%"}
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.rcm.astag.meeting_attendees_groups[0].team_name), 1),
                    _hoisted_7
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("table", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.astag.meeting_attendees_groups, (mag, magindex) => {
                  return (_openBlock(), _createElementBlock("tr", { key: magindex }, [
                    _createElementVNode("td", _hoisted_11, [
                      (mag.profile_image_urls && mag.profile_image_urls[0])
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            "data-imagetype": "External",
                            src: mag.profile_image_urls[0],
                            width: "80",
                            height: "80",
                            style: {"border-radius":"50%"}
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(mag.team_name), 1),
                      _hoisted_15
                    ])
                  ]))
                }), 128))
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}